if (locale === 'ar'){
  Flickity.defaults.rightToLeft = false;
}
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

function cssVariables(){
  const header = document.getElementById('HeaderWrapper');
  const mobileBar = document.getElementById('mobile-bar');

  let headerHeight = 0;
  let mobileBarHeight = 0;

  if (header){
    headerHeight = header.offsetHeight;
  }

  if (mobileBar){
    mobileBarHeight = mobileBar.offsetHeight;
  }

  document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
  document.documentElement.style.setProperty('--mobileBarHeight', `${mobileBarHeight}px`);
}

window.addEventListener("DOMContentLoaded", () => {
  cssVariables();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(() => {
      cssVariables();
    }, 150); // Throttle to 150ms
  });

  document.addEventListener("collection:section:loaded", (evt) => {
    
    let collectionSectionsSlider;
    let carouselContainer = evt.detail.container;
    if (!carouselContainer.classList.contains('product-grid')){
      carouselContainer = evt.detail.container.querySelector('.product-grid');
    }
    collectionSectionsSlider = new Flickity(
      carouselContainer,
      {
        cellAlign: "left",
        contain: true,
        groupCells: true,
        // autoPlay: 2000,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        watchCSS: true,
        pageDots: true,
      }
    );
    window.addEventListener("resize", () => {
      collectionSectionsSlider.resize();
    });
  });

  const addedToCartContainer = document.querySelector(
    "#added-to-cart-notification"
  );

  if (addedToCartContainer) {
    const productContainer = addedToCartContainer.querySelector(
      "#added-to-cart-product"
    );
    const cartQuantityBubble = document.querySelector(".cart-link__bubble-num");

    document.addEventListener("ajaxProduct:added", function (evt) {

      let product = evt.detail.product;
      if ('items' in evt.detail.product){ 
        product = evt.detail.product.items[0];
      }
      // console.log(evt.detail);

      // const requestUrl = "products/sebamed-baby-lotion-200-ml?view=added-to-cart";
      const requestUrl = `${window.Shopify.routes.root}products/${product.handle}?view=added-to-cart`;
      fetch(requestUrl)
        .then((response) => response.text())
        .then((data) => {
          productContainer.innerHTML = data;

          addedToCartContainer.classList.add("visible");

          var selector = new theme.QtySelector(productContainer, {
            namespace: ".cart-page",
            isCart: true,
          });

          const productItem = productContainer.querySelector(".cart__item");
          const cartCountEl = productContainer.querySelector('#added-to-cart-notification__count');
          const cartValueElem = productContainer.querySelector('.cart__price [data-price]');
          const { key } = productItem.dataset;
          window.app.currencyExchange.convertPrices([cartValueElem]);

          document.addEventListener("cart:quantity.cart-page", (e) => {
            const productKey = e.detail[0];
            const quantity = e.detail[1];
            theme.cart.changeItem(productKey, quantity);

            setTimeout( () => {
              fetch(`${window.Shopify.routes.root}cart.js`)
                .then((response) => response.json())
                .then((data) => {
                  cartQuantityBubble.innerHTML = data.item_count;
                  cartCountEl.setAttribute('data-content', data.item_count)
                  cartValueElem.setAttribute('data-price', (data.total_price / 100));
                  window.app.currencyExchange.convertPrices([cartValueElem]);
                })
                .catch((e) => {
                  console.error(e);
                });
            },400);
          });

          // const addedToCartForm = document.querySelector(
          //   "#added-to-cart-notification form"
          // );

          // var cartForm = new theme.CartForm(addedToCartForm);
          let closeTimout;
          function initTimeout() {
            closeTimeout = setTimeout(() => {
              addedToCartContainer.classList.remove("visible");
            }, 2500);
          }

          initTimeout();

          document.body.addEventListener("click", function (event) {
            if (addedToCartContainer.contains(event.target)) {
              clearTimeout(closeTimeout);
              initTimeout();
            }
          });
        });
    });
  }

  const customLinks = document.querySelectorAll("[data-href]");
  if (customLinks.length){
    customLinks.forEach((link)=>{
      const {href} = link.dataset;
      if (href){
        link.addEventListener('click', () => {
          window.location.href = href;
        })
      }
    })
  }

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('aa-DetachedSearchButton')){
      setTimeout(()=>{
        const algoliaInput = document.querySelector('.aa-Input');
        if (algoliaInput){
          algoliaInput.focus();
          // algoliaInput.click();
        }
      },300);
    }
  });

  const addToCartBtns = document.querySelectorAll('.quick-add-btn');
  const btnsStructure = {};

  if (addToCartBtns.length){ 
    addToCartBtns.forEach(btn =>{
      const { id } = btn.dataset;
      btnsStructure[id] = btn;
    });
  }

  const checkProductsInCart = () => {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach(item => {
        const id = item.id;
        const quantity = parseInt(item.quantity);
        
        const btn = btnsStructure[id];
        if (btn){
          btn.classList.add('in-cart');
        }

        // const quantityInputs = document.querySelectorAll(`.js-qty__num[data-product-id="${id}"]`);
        const quantityInput = document.querySelector(`.cart__items .js-qty__num[data-product-id="${id}"]`);

        if (quantityInput){

          const max = parseInt(quantityInput.getAttribute('max'));

          if (max && quantity >= max){
            if (btn){
              btn.classList.add('limit-reached');
              btn.disabled = true;
            }
            // if (pdpAddToCart){
            //   pdpAddToCart.classList.add('limit-reached');
            // }
            quantityInput.value = max;
            // quantityInput.dispatchEvent(new Event('change'));
          }else{
            if (btn){
              btn.classList.remove('limit-reached');
              btn.disabled = false;
            }
            // if (pdpAddToCart){
            //   pdpAddToCart.classList.remove('limit-reached');
            // }
          }
        }
        // quantityInputs.forEach(input => {
        //   const max = parseInt(input.getAttribute('max'));
        //   if (max && quantity >= max){
        //     btn.classList.add('limit-reached');
        //     quantity
        //   }
        // })
      });
    });
  }

  checkProductsInCart();
  document.addEventListener("ajaxProduct:added", function (evt) {
    checkProductsInCart();
  });

  document.addEventListener("cart:updated", function (evt) {
    checkProductsInCart();
  })

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart__item-remove');
    if (btn){
      const {key} = btn.dataset;
      theme.cart.changeItem(key, 0);
      setTimeout(()=>{
        document.dispatchEvent(new CustomEvent('cart:build'));
      },500);
      btn.addEventListener('click', () =>{
      })

    }
  })

  const langSwitcherToggles = document.querySelectorAll('[data-lang-switcher-toggle]');
  const langSwitcherModal = document.querySelector('.lang-switcher__modal');

  if (langSwitcherModal){
    if (langSwitcherToggles.length){
      langSwitcherToggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          langSwitcherModal.classList.add('active');
        })
      })
    }
    document.body.addEventListener("click", function (event) {
      if (event.target === langSwitcherModal || event.target.closest('.lang-switcher__close')) {
        langSwitcherModal.classList.remove('active');
      }
    });
  }

  window.addEventListener('load', () => {
    cssVariables();
    setTimeout(()=>{
      
    const visitorCounter = document.querySelector('.visitor-counter-content-box-carecartbysalespop-2020');
    const salesCounter = document.querySelector('.sold-counter-content-box');
    const salesPopupContainer = document.createElement('div');
      salesPopupContainer.classList.add('sales-popup-container');
  

      if (visitorCounter || salesCounter){
        salesPopupContainer.appendChild(visitorCounter);
        salesPopupContainer.appendChild(salesCounter);
      
        productMetaBox.appendChild(salesPopupContainer);
      }

    },1000)
  });

  window.addEventListener('pagehide', () => {
    const checkoutButtons = document.querySelectorAll('button[name="checkout"]');
    checkoutButtons?.forEach((btn) => {
      if (btn.classList.contains('aiod_checkout_clicked')){
        btn.classList.remove('aiod_checkout_clicked');
        btn.classList.add('aiod_cart_loaded');
      }
    })
  });
});
